import { __rest } from "tslib";
import * as React from 'react';
import { Card, CardHeader, CardTitle, CardBody, CardFooter } from '@patternfly/react-core';
import { css } from '@patternfly/react-styles';
import { getUniqueId } from '@patternfly/react-core';
export class CatalogTile extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = (e) => {
            const { onClick, href } = this.props;
            if ("type" in e && e.type === "click" && onClick) {
                // It's a MouseEvent
                const mouseEvent = e;
                if (mouseEvent.metaKey || // Cmd key (Mac)
                    mouseEvent.ctrlKey || // Ctrl key
                    mouseEvent.shiftKey // Shift key
                ) {
                    window.open(href, '_blank');
                    return;
                }
            }
            else if (href) {
                window.open(href, '_blank');
            }
            if (onClick) {
                onClick(e);
            }
        };
        this.renderBadges = (badges) => {
            if (!badges || !badges.length) {
                return null;
            }
            return (React.createElement("div", { className: "catalog-tile-pf-badge-container" }, badges.map((badge, index) => (React.createElement("span", { key: `badge-${index}` }, badge)))));
        };
        this.generatedId = getUniqueId('pf-catalog-tile');
    }
    render() {
        const _a = this.props, { id, className, featured, onClick, href, icon, iconImg, iconAlt, iconClass, badges, title, vendor, description, footer, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ref, children } = _a, props = __rest(_a, ["id", "className", "featured", "onClick", "href", "icon", "iconImg", "iconAlt", "iconClass", "badges", "title", "vendor", "description", "footer", "ref", "children"]);
        return (React.createElement(Card, Object.assign({ id: id || this.generatedId, className: css('catalog-tile-pf', { featured }, className), variant: featured ? 'secondary' : 'default', isClickable: (onClick || href) ? true : false }, props),
            (badges.length > 0 || iconImg || iconClass || icon || onClick || href) && (React.createElement(CardHeader, { selectableActions: (onClick || href) && {
                    selectableActionId: id + '-input',
                    onClickAction: (e) => this.handleClick(e),
                    selectableActionAriaLabelledby: id
                } },
                iconImg && React.createElement("img", { className: "catalog-tile-pf-icon", src: iconImg, alt: iconAlt }),
                !iconImg && (iconClass || icon) && React.createElement("span", { className: `catalog-tile-pf-icon ${iconClass}` }, icon),
                badges.length > 0 && this.renderBadges(badges))),
            React.createElement(CardTitle, { className: "catalog-tile-pf-header" },
                React.createElement("div", { className: "catalog-tile-pf-title" }, title),
                vendor && React.createElement("div", { className: "catalog-tile-pf-subtitle" }, vendor)),
            (description || children) && (React.createElement(CardBody, { className: "catalog-tile-pf-body" },
                description && (React.createElement("div", { className: "catalog-tile-pf-description" },
                    React.createElement("span", { className: css({ 'has-footer': footer }) }, description))),
                children)),
            footer && React.createElement(CardFooter, { className: "catalog-tile-pf-footer" }, footer)));
    }
}
CatalogTile.displayName = 'CatalogTile';
CatalogTile.defaultProps = {
    id: null,
    className: '',
    featured: false,
    onClick: null,
    href: null,
    iconImg: null,
    iconAlt: '',
    iconClass: '',
    icon: null,
    badges: [],
    vendor: null,
    description: null,
    footer: null,
    children: null
};
//# sourceMappingURL=CatalogTile.js.map